import React, { useEffect } from "react";
import { Container } from "./DeviceList.styles";
import { DeviceSummaryStats, DeviceList as DeviceListWidget } from "uis/MeetingRoomDeviceManagement";
import {
  getDeviceSummaryStats,
  getMeetingRoomDeviceList,
  TDeviceSummaryStats,
  TExtendedMeetingRoom,
} from "apis/meeting-room-device";
import { AmplitudeService } from "utils/amplitude.service";
import { useRecoilValue } from "recoil";
import { workspace } from "recoil/recoilState";

type DeviceListProps = {
  isShow: boolean;
  isActiveProblemMeetingRoom: boolean;
};
const DeviceList: React.FC<DeviceListProps> = ({ isShow, isActiveProblemMeetingRoom }) => {
  const amplitudeService = new AmplitudeService();
  const workspaceInfo = useRecoilValue(workspace);
  const [summaryStats, setSummaryStats] = React.useState<TDeviceSummaryStats | null>(null);
  const [meetingRoomList, setMeetingRoomList] = React.useState<TExtendedMeetingRoom[]>([]);

  const getSummaryStats = async () => {
    const res = await getDeviceSummaryStats();
    setSummaryStats(res);
  };

  const getMeetingRoomList = async (isActiveProblemMeetingRoom: boolean) => {
    const res = await getMeetingRoomDeviceList(isActiveProblemMeetingRoom);
    amplitudeService.logMeetingRoomDeviceManagementPageView(workspaceInfo?.id ?? "", workspaceInfo?.name ?? "", res);
    setMeetingRoomList(res);
  };

  useEffect(() => {
    if (!isShow) return;
    getSummaryStats();
    getMeetingRoomList(isActiveProblemMeetingRoom);
  }, [isShow, isActiveProblemMeetingRoom]);

  return (
    <Container isShow={isShow}>
      <DeviceSummaryStats
        totalMeetingRoom={summaryStats?.totalNum ?? 0}
        normalMeetingRoom={summaryStats?.normalNum ?? 0}
        errorMeetingRoom={summaryStats?.abnormalNum ?? 0}
      />
      <DeviceListWidget meetingRoomList={meetingRoomList} />
    </Container>
  );
};

export default React.memo(DeviceList);
